import React from 'react'
import { Footer } from '../components/Footer'
import { Menu } from '../components/Menu'
import { ListProjects } from '../Home/ListProjects'
import { HowWeDow } from './HowWeDow'
import { Presentation } from './Presentation'


export const Projects = () => {
    return (
        <>
            <Menu />
            <Presentation/>
            <ListProjects/>  
            <HowWeDow/>
            <Footer />
        </>
    )
}
